<main class="mat-body" *ngIf="visible">
    <div class="bg-white">
        <div class="container">
            <div class="row justify-content-center text-center">
                <div class="col-8 mt-5">
                    <thr-radio-button class="justify-content-center" [size]="160" [checked]="true">
                        <i class="icon-advice"></i>
                    </thr-radio-button>
                    <label class="mat-headline text-blue" [innerHTML]="'contract.advice.title'|translate"></label>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row justify-content-center text-center my-4">
            <div class="col-8 col-sm-6 col-md-5 col-lg-4 mt-5">
                <button
                    type="button"
                    class="full-width mat-elevation-z0 mt-4"
                    mat-raised-button
                    color="white"
                    (click)="onClick(AdvisoryModel.P)"
                >
                    {{ 'contract.advice.punctual'|translate }}
                </button>
            </div>
            <div class="col-8 col-sm-6 col-md-5 col-lg-4 offset-md-2 mt-5">
                <button
                    type="button"
                    class="full-width mat-elevation-z0 mt-4"
                    mat-raised-button
                    color="white"
                    (click)="onClick(AdvisoryModel.A)"
                >
                    {{ 'contract.advice.recurrent'|translate }}
                </button>
            </div>
        </div>
    </div>
</main>
